<template>

    <div id="agility_tab" class="flex_content" v-if="currentEval.saven_test">

        <div class="container">

            <div class="strength_scores">
                <div class="strength_item">
                    <StrengthCustomScore :dimId="currentEval.saven_test.strengths_order[0][0]" :scoreIndex="1"  :titles="dimensionsPlan.strenghts_custom_data" />
                    <div class="strenght_def" v-html="dimensionsPlan.strenghts_custom_data[currentEval.saven_test.strengths_order[0][0]].def[$i18n.locale]"></div>
                </div>
                <div class="strength_item">
                    <StrengthCustomScore :dimId="currentEval.saven_test.strengths_order[1][0]" :scoreIndex="2"  :titles="dimensionsPlan.strenghts_custom_data" />
                    <div class="strenght_def" v-html="dimensionsPlan.strenghts_custom_data[currentEval.saven_test.strengths_order[1][0]].def[$i18n.locale]"></div>
                </div>
                <div class="strength_item">
                    <StrengthCustomScore :dimId="currentEval.saven_test.strengths_order[2][0]" :scoreIndex="3"  :titles="dimensionsPlan.strenghts_custom_data" />
                    <div class="strenght_def" v-html="dimensionsPlan.strenghts_custom_data[currentEval.saven_test.strengths_order[2][0]].def[$i18n.locale]"></div>
                </div>

                <!--
                <StrengthCustomScore :dimId="currentEval.saven_test.strengths_order[3][0]" :scoreIndex="4"  :titles="dimensionsPlan.strenghts_custom_data" />
                <StrengthCustomScore :dimId="currentEval.saven_test.strengths_order[4][0]" :scoreIndex="5"  :titles="dimensionsPlan.strenghts_custom_data" />
                -->

            </div>

        </div>
    </div>

</template>

<script>
import StrengthCustomScore from '../scores/strengthCustomScore'

export default {
    name: 'StrengthCustomTab',
    components: {
        StrengthCustomScore
    },
    beforeCreate() {

    },
    data(){
        return {}
    },
    computed: {
        currentEval(){
            return this.$store.state.EvalStore.currentEval
        },
        dimensionsPlan(){
            return this.$store.state.EvalStore.currentEval.saven_test.dimensions_plan
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" >
.strength_scores{
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .strength_item{
        max-width: 500px;
        .strenght_def{
            padding: 20px 0 30px;
            p, span, strong, *{
                color: #8f9aaa!important;
            }
        }
    }
}
</style>